/**
 * Lab ColorItems / reasonColor — Betfair vendor bifurcation on ticker rows.
 * Adaptor stamps metadata.flagReason + isBetfairFlagged (see Vendors-Orders-Adaptor).
 */

export const BETFAIR_REASON_COLORS = {
  IncorrectPrice: '#FF55BB',
  Sniping: '#00A9FF',
  LowLiquidity: '#A66CFF',
} as const

export type BetfairReason = keyof typeof BETFAIR_REASON_COLORS

export const BETFAIR_REASON_LEGEND: ReadonlyArray<{
  reason: BetfairReason
  color: string
}> = [
  { reason: 'IncorrectPrice', color: BETFAIR_REASON_COLORS.IncorrectPrice },
  { reason: 'Sniping', color: BETFAIR_REASON_COLORS.Sniping },
  { reason: 'LowLiquidity', color: BETFAIR_REASON_COLORS.LowLiquidity },
]

/** Lab reasonColor → row marker (Member cell; drives `tr:has(...)` tint). */
export function betfairReasonCssClass(reason: string | null | undefined): string | null {
  if (reason === 'IncorrectPrice') return 'w7-bm-reason--incorrect-price'
  if (reason === 'Sniping') return 'w7-bm-reason--sniping'
  if (reason === 'LowLiquidity') return 'w7-bm-reason--low-liquidity'
  return null
}

/** Dot-only class — must not match row `:has(.w7-bm-reason--*)` when member flags win. */
export function betfairReasonDotClass(reason: string | null | undefined): string | null {
  if (reason === 'IncorrectPrice') return 'w7-bm-reason-dot--incorrect-price'
  if (reason === 'Sniping') return 'w7-bm-reason-dot--sniping'
  if (reason === 'LowLiquidity') return 'w7-bm-reason-dot--low-liquidity'
  return null
}

/** Lab: show colored circle when flagged + Betfair-flagged + reason. */
export function showBetfairReasonDot(bet: {
  isFlagged?: boolean | null
  isBetfairFlagged?: boolean | null
  reason?: string | null
}): boolean {
  return Boolean(bet.isFlagged && bet.isBetfairFlagged && bet.reason)
}

/**
 * Lab tr ng-class reasonColor — only when no member/smart/blocked overlays.
 * Member flags beat Betfair reason row tint.
 */
export function betfairReasonRowClass(opts: {
  reason?: string | null
  isFlagged?: boolean | null
  isBetfairFlagged?: boolean | null
  memberFlag: string | null
  smartUserComment?: string | null
}): string | null {
  if (opts.memberFlag) return null
  if (opts.smartUserComment?.trim()) return null
  if (!showBetfairReasonDot(opts)) return null
  return betfairReasonCssClass(opts.reason)
}
